import { PhoneCheckContext, Products } from '@site-mate/sitemate-global-shared/lib';

import { GlobalApiClient } from './global-api.client';

interface SendSignupOtpResponse {
  twoFactorId: string;
  status: string;
}

interface VerifySignupOtpResponse {
  verificationToken: string;
  phoneNumber: string;
  expiresAt: string;
}

export const signupOtpService = {
  async send(
    phone: string,
    recaptchaToken: string,
    deliveryMethod: 'sms' | 'call' = 'sms',
    isFallback = false,
    context?: PhoneCheckContext,
  ): Promise<SendSignupOtpResponse> {
    const result = await GlobalApiClient.post<SendSignupOtpResponse>('/auth/phone-verification/send', {
      phoneNumber: phone,
      recaptchaToken,
      deliveryMethod,
      product: Products.Gearbelt,
      ...(isFallback ? { isFallback: true } : {}),
      ...(context ? { context } : {}),
    });
    return result.data;
  },

  async verify(twoFactorId: string, code: string): Promise<VerifySignupOtpResponse> {
    const result = await GlobalApiClient.post<VerifySignupOtpResponse>('/auth/phone-verification/verify', {
      twoFactorId,
      code,
    });
    return result.data;
  },
};
